export default __webpack_public_path__ + "static/flags-16b2a7a7b43a541b2c74c88200afe251.svg";